<script setup>
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'
import ThemeSwitcher from './ThemeSwitcher.vue'
import { NotificationBell } from '@/components/notifications'

const { t } = useI18n()
const authStore = useAuthStore()
const uiStore = useUiStore()
</script>

<template>
  <header class="app-header">
    <div class="header-content">
      <!-- Mobile Menu Toggle -->
      <button class="menu-toggle" @click="uiStore.toggleSidebar" aria-label="Menu">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 12h18M3 6h18M3 18h18"/>
        </svg>
      </button>
      
      <!-- Spacer for centering on desktop -->
      <div class="header-spacer"></div>
      
      <!-- Right Section -->
      <div class="header-right">
        <ThemeSwitcher />
        
        <!-- Notifications Bell -->
        <NotificationBell v-if="authStore.isAuthenticated" />
        
        <!-- User info (desktop only, minimal) -->
        <span v-if="authStore.isAuthenticated && authStore.isDeveloper" class="role-badge developer">DEV</span>
      </div>
    </div>
  </header>
</template>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--color-background);
  border-bottom: 1px solid var(--color-border);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 20px;
}

.header-spacer {
  flex: 1;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--color-text);
  border-radius: 8px;
  transition: background 0.2s;
}

.menu-toggle:hover {
  background: var(--color-background-secondary);
}

/* На десктопе прячем кнопку меню */
@media (min-width: 1025px) {
  .menu-toggle {
    display: none;
  }
}

/* Role Badge */
.role-badge {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.role-badge.developer {
  background: #6366f1;
  color: white;
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .header-content {
    height: 56px;
    padding: 0 12px;
  }
  
  .menu-toggle {
    width: 44px;
    height: 44px;
  }
  
  .header-right {
    gap: 8px;
  }
  
  .role-badge {
    display: none;
  }
}
</style>
